import React from "react";
import {
  SlidersHorizontal,
  TrendingUp,
  Layers,
  Server,
  Gauge,
  Hexagon,
  Settings2,
  Terminal,
  Shield,
  Smartphone,
  CloudCog,
  Zap,
  Upload,
  LineChart,
  FileText,
  Coins,
  Construction,
  Bug,
  Brain,
  Wrench,
  Clock,
  CloudUpload,
  Monitor,
  HeartHandshake,
  Lock,
  ClipboardCheck,
  Sparkles,
  ShieldCheck,
  ShieldAlert,
  UserCheck,
  Globe,
  Code2,
  Bot,
  Activity,
  Settings,
  RefreshCw,
  LayoutDashboard,
  Cloud,
  Users,
  Cpu,
  Network,
  ArrowUp,
  ArrowDown,
  X,
  Send,
  ChevronDown,
  Rocket,
  RotateCw,
  CheckCircle2,
  Mail,
  Phone,
  MapPin,
  Ruler,
  BadgeCheck,
  ChevronRight,
  ChevronLeft,
  ArrowRight,
  ArrowLeft,
  Calendar,
  MessageSquare,
  Search,
  Sun,
  Moon,
  Menu,
  Check,
  HelpCircle,
  type LucideProps
} from "lucide-react";

export const iconMap = {
  tune: SlidersHorizontal,
  trending_up: TrendingUp,
  layers: Layers,
  dns: Server,
  speed: Gauge,
  token: Hexagon,
  settings_applications: Settings2,
  terminal: Terminal,
  security: Shield,
  smartphone: Smartphone,
  cloud_sync: CloudCog,
  offline_bolt: Zap,
  publish: Upload,
  analytics: LineChart,
  assignment: FileText,
  file_text: FileText,
  monetization_on: Coins,
  engineering: Construction,
  bug_report: Bug,
  psychology: Brain,
  build: Wrench,
  update: Clock,
  backup: CloudUpload,
  monitor: Monitor,
  health_and_safety: HeartHandshake,
  vpn_lock: Lock,
  lock: Lock,
  assignment_turned_in: ClipboardCheck,
  cleaning_services: Sparkles,
  gpp_good: ShieldCheck,
  policy: ShieldAlert,
  admin_panel_settings: UserCheck,
  web: Globe,
  phone_android: Smartphone,
  api: Code2,
  code: Code2,
  smart_toy: Bot,
  database: Server,
  query_stats: Activity,
  settings_suggest: Settings,
  sync: RefreshCw,
  dashboard: LayoutDashboard,
  cloud: Cloud,
  cloud_done: Cloud,
  groups: Users,
  public: Globe,
  precision_manufacturing: Cpu,
  hub: Network,
  arrow_upward: ArrowUp,
  arrow_downward: ArrowDown,
  arrow_down: ArrowDown,
  close: X,
  send: Send,
  expand_more: ChevronDown,
  keyboard_arrow_down: ChevronDown,
  rocket_launch: Rocket,
  refresh: RotateCw,
  check_circle: CheckCircle2,
  mail: Mail,
  call: Phone,
  location_on: MapPin,
  architecture: Ruler,
  verified: BadgeCheck,
  chevron_right: ChevronRight,
  chevron_left: ChevronLeft,
  arrow_forward: ArrowRight,
  arrow_back: ArrowLeft,
  calendar_today: Calendar,
  chat: MessageSquare,
  light_mode: Sun,
  dark_mode: Moon,
  menu: Menu,
  check: Check,
  search: Search,
  bolt: Zap,
  shield: Shield,
  verified_user: ShieldCheck
};

export type IconName = keyof typeof iconMap;

interface IconProps extends Omit<LucideProps, "name"> {
  name: IconName | string;
  size?: number | string;
  className?: string;
}

export default function Icon({ name, className = "", size, ...props }: IconProps) {
  const normalizedKey = (name || "").trim().toLowerCase();
  const LucideIconComponent = iconMap[normalizedKey as IconName] || HelpCircle;

  return (
    <LucideIconComponent 
      className={className} 
      size={size} 
      {...props} 
    />
  );
}
